import { Flow, IRouterPage, States } from '../interfaces/interfaces';

export const initialState: States = {
    activePage: {} as IRouterPage,
    error: {
        redirectToPage: undefined,
        errorMessage: '',
        hasError: false,
        manufacturerDataDeficient: false
    },
    purchaseComplete: false,
    reloadStakeholder: true,
    selection: {
        vehicleSelectionMode: 'DMR',
        bankAccountNumber: '',
        bankRegNumber: '',
        didClickFinalize: false,
        didClickFetchPackages: false,
        package: null,
        criticalIllnessCoverage: null,
        eboksSubscription: false,
        packageInfo: null,
        flow: Flow.NOT_SET,
        premiumRate: '12',
        fullName: '',
        viNumber: '',
        partnerInfo: null
    },
    fieldValidation: {},
    model: {
        CAR: {
            dmr: null,
            packages: null,
            stakeholder: null,
            status: null,
            giftcard: null,
            eboks: null,
            pbs: null,
            customerMarking: null,
            coverageTexts: null,
            manufactors: [],
            fuels: [],
            models: [],
            years: [],
            engines: [],
            powers: [],
            dfimStatus: true
        },
        CHILD: {
            packages: null,
            stakeholder: null,
            numberOfChildren: 1,
            childList: [],
            pbs: null,
            customerMarking: null,
            coverageTexts: [],
            disabilitySum: 1000000,
            skipCriticalIllnessPage: null
        }
    },
    labels: {},
    shouldCheckBBR: false, //used in cpr view and UserProvider
    runCriticalIllnessSplitTest: true
};
